import React, { useState } from "react";
import LoadingWithLable from "../../../../../ReusableComponents/Loading/LoadingWithLable";
import Highlighter from "react-highlight-words";
import useSearchPagination from "../../../../../ReusableComponents/SearchPagination/useSearchPagination";
import { setAppError } from "../../../../../store/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { CgSpinner } from "react-icons/cg";
import nodeinstance from "../../../../../nodeInstance";
import UploadFilePopUp from "../../../../../ReusableComponents/UploadFile/uplaodFile";
import QiwaPopUp from "../QiwaPopUp";
import NakalaKaflaPopUp from "../../NakalaKafala/NakalaKaflaPopUp";

export default function ListQiwaContractRenewal_OPS({
  token,
  titles = [],
  list = [],
  loading,
  updateData,
}) {
  const [Popup, setPopUp] = useState(false);
  const [listData, setListData] = useState({});
  const [searchWords, setSearchWords] = useState([]);

  const dispatch = useDispatch();

  const {
    NoDataFound,
    Pagination,
    PaginationIndex,
    Search,
    CountPerPage,
    currentList,
  } = useSearchPagination(list?.data || []);

  const apiCall = () => {
    updateData("123654");
    setListData({});
  };

  const renewClicked = async (data) => {
    // alert(".............................");
    const reqObj = {
      employee_id: data,
    };
    try {
      const response = await nodeinstance.put(
        `/qiwaContract/updatebyOPSRenew`,
        reqObj,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        console.log("response succces to be seen here", response);
        apiCall()
      }
    } catch (error) {
      console.log("error to be seen in console", error);
    }
  };

  return (
    <>
      <div className="pt-2 uppercase">
        <div className="flex flex-wrap  gap-2 w-full items-center flex flex-row-reverse">
          <Search
            searchKey={[
              "employee_id",
              "visa_reference_number",
              "border_number",
            ]}
            setSearchWords={setSearchWords}
          />
        </div>
        <p className="text-sm w-full text-right font-medium mb-1">{`Slide / scroll to right >`}</p>
        <CountPerPage />
        <div
          className={`grid grid-cols-table-qiwa-contract auto-cols-min gap-5 p-6 bg-white w-full overflow-x-scroll lg:overflow-auto items-baseline  rounded-md `}
        >
          {titles.map((t, index) => (
            <p key={index} className="font-semibold uppercase">
              {t}
            </p>
          ))}
          {list?.isLoading && <LoadingWithLable className="col-span-6" />}
          {!list?.isLoading && <NoDataFound />}

          {!list?.isLoading
            ? currentList?.map((list, index) => (
                <React.Fragment key={index}>
                  <PaginationIndex index={index} />
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.employee_id || "-"}
                    />
                  </p>

                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.employee_name || "-"}
                    />
                  </p>

                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.religion || "-"}
                    />
                  </p>
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.nationality || "-"}
                    />
                  </p>
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.current_sponsor || "-"}
                    />
                  </p>
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.client || "-"}
                    />
                  </p>
                  <p>{list.uploaded_count}</p>
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={
                        list.qiwa_contract_status === "Renew Pending Ops"
                          ? "PENDING"
                          : list.qiwa_contract_status || "-"
                      }
                    />
                  </p>

                  <button
                    className={
                      "p-1 px-2 rounded-md  bg-red text-white text-xs p-2"
                    }
                    onClick={() => {
                      renewClicked(list.employee_id);
                    }}
                  >
                    RENEWAL
                  </button>
                  <hr
                    className={`border-[1.5px] border-slate-100  w-full col-span-full `}
                  />
                </React.Fragment>
              ))
            : ""}
        </div>
        <Pagination />
      </div>
      {Popup ? (
        <NakalaKaflaPopUp
          PopUp={Popup}
          setPopUp={setPopUp}
          title={""}
          data={listData}
        />
      ) : (
        ""
      )}
    </>
  );
}
